export enum EnvName {
    TESTING = 'masterdev',
    DEV = 'test',
    PROD = 'master',
}
